class Navigation {
    constructor(el) {
        el.navigation = this;
        this.scope = el;
        this.links = el.querySelectorAll("[data-details]");
        this.openLink = null;
        this.bindClick = e => {
            if (e.target.closest("[data-mega-nav]") === null) {
                this.closeMegaNav();
                document.removeEventListener("click", this.bindClick);
            }
        };
        this.bindTab = (e) => {
            if (e.target.closest("[data-mega-nav]") === null && e.key === "Tab") {
                this.closeMegaNav();
                document.removeEventListener("keyup", this.bindTab);
            }
        };
        this.bindEvents();
    }

    bindEvents(){
        this.links.forEach(detail =>{

            const listItem = detail.parentElement;

            detail.querySelector("[data-summary]").addEventListener("click", e=>{
                if(!listItem.mouseenter){

                    e.preventDefault();

                    if(detail.closest(".navigation__items__item").classList.contains("navigation__items__item--open")){
                        this.closeMegaNav();
                    }else{
                        detail.closest(".navigation__items__item").classList.add("navigation__items__item--open");
                        setTimeout(()=>{
                            this.openMegaNav(detail);
                        }, 100)
                    }   
                }else{
                   listItem.mouseenter = false; 
                }
            })
            
            listItem.addEventListener('mouseenter', e => {
                if(viewport() > 1){
                    listItem.mouseenter = true;
                    e.preventDefault();
                    detail.closest(".navigation__items__item").classList.add("navigation__items__item--open");
                    this.openMegaNav(detail);
                } 
            });
            listItem.addEventListener('mouseleave', (e) => {
                if(viewport() > 1){
                    detail.closest(".navigation__items__item").classList.remove("navigation__items__item--open");
                    e.preventDefault();
                    this.closeMegaNav();
                }
            });
      
            detail.querySelector("[data-back]").addEventListener("click", ()=>{
                detail.closest(".navigation__items__item").classList.remove("navigation__items__item--open");
                this.closeMegaNav();
            });
         
        })
    }

    openMegaNav(detail){
        this.scope.style.setProperty('--mega-nav-offset-height', `${this.scope.querySelector("[data-mega-nav]").offsetHeight}px`);

        let openNavEvent = new Event("open");
        this.scope.dispatchEvent(openNavEvent);
        if(viewport() > 2){
            document.querySelector("html").classList.add("overlay");
            document.querySelector("html").classList.add("nav-open");
        }
        this.scope.classList.add("navigation--open");
        
        this.openLink = detail;

        setTimeout(()=>{
            document.addEventListener("click", this.bindClick);
            document.addEventListener("keyup", this.bindTab);
        }, 100);
    }

    closeMegaNav(){
        if(this.openLink !== null){
            document.querySelector("html").classList.remove("overlay");
            this.scope.classList.remove("navigation--open");
            this.openLink.closest(".navigation__items__item").classList.remove("navigation__items__item--open");
            this.openLink = null;
            document.querySelector("html").classList.remove("nav-open");
            document.querySelector("html").classList.add("nav-closing");
            setTimeout(()=>{
                document.querySelector("html").classList.remove("nav-closing");
            }, 500)
        }
    }

}

ControlBinders.register(`[data-navigation]`, el => new Navigation(el));